import ApiService from "@/modules/api/api.service";

export default class BulkShipmentExportsRepository {
  protected resourceName = "bulk_shipment_exports";

  constructor(protected api: ApiService) { }

  public async getPdfByShipmentId(shipmentId: string): Promise<string> {
    const result = await this.api.get(`${this.resourceName}/${shipmentId}/pdf`);

    return (result.data as { downloadUrl: string }).downloadUrl;
  }
}
